import {
  Button,
  ChakraFlex,
  ChakraGridItem,
  ChakraText,
  EquipUITheme,
} from '@equip.health/ui';

const { label } = EquipUITheme.typography;
const TOP_LEVEL_ID = 'edit-task-confirmation';

type EditTaskConfirmDrawerProps = {
  editTaskError: string;
  handleCancel: () => void;
  handleSave: () => void;
  isSaveButtonDisabled: boolean;
  isVisible: boolean;
};

const EditTaskConfirmDrawer = ({
  editTaskError,
  handleCancel,
  handleSave,
  isSaveButtonDisabled,
  isVisible,
}: EditTaskConfirmDrawerProps) => (
  <ChakraGridItem
    backgroundColor="neutral.background.primary"
    bottom={0}
    boxShadow="0px -8px 12px rgba(0, 0, 0, 0.08)"
    display="flex"
    height={isVisible ? '90px' : '0px'}
    justifyContent="space-between"
    overflow="hidden"
    padding={isVisible ? '24px' : '0px 24px'}
    right={0}
    transition="height 0.25s linear, padding 0.25s linear"
    zIndex={2}
  >
    <Button
      colorScheme="gray"
      id={`${TOP_LEVEL_ID}__discard`}
      onClick={handleCancel}
      variant="ghost"
    >
      Discard
    </Button>
    <ChakraFlex alignItems="center">
      {editTaskError && (
        <ChakraText
          {...label}
          color="error"
          id={`${TOP_LEVEL_ID}__save-error-text`}
          marginRight="16px"
        >
          Error saving task
        </ChakraText>
      )}
      <Button
        id={`${TOP_LEVEL_ID}__save`}
        isDisabled={isSaveButtonDisabled}
        onClick={() => handleSave()}
        variant="solid"
      >
        Save changes
      </Button>
    </ChakraFlex>
  </ChakraGridItem>
);

export default EditTaskConfirmDrawer;
